module.exports = __webpack_public_path__ + "img/featured-tweet-right-line-flush.132251fb.svg";